import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_private/_route/_internal/pipeline-submissions/',
)({
  beforeLoad: () => {
    throw redirect({
      replace: true,
      search: {
        order: 'desc',
        sort: 'created',
        status: ['active'],
      },
      to: '/pipelines',
    });
  },
});
